var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number-card',{attrs:{"bold":_vm.bold,"color-code":_vm.colorCode,"amount":_vm.amount,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }